"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = _interopRequireDefault(require("fast-deep-equal/es6/react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var areEqual = function areEqual(prevProps, nextProps) {
  return (0, _react2["default"])(prevProps, nextProps);
};

var HotJarIdentifier = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$userFields = _ref.userFields,
      userFields = _ref$userFields === void 0 ? {} : _ref$userFields;
  (0, _react.useEffect)(function () {
    if (typeof window !== "undefined") {
      var id = Math.round(Math.random() * 9999999999999999).toString();
      window.engagingUserSessionId = id;
      console.log("Engaging User Session ID", id);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (typeof window !== "undefined") {
      if (!window.hj) {
        window.hj = window.hj || function () {
          ;
          (hj.q = hj.q || []).push(arguments);
        };
      }

      window.hj("identify", window.engagingUserSessionId, userFields);
      console.log("Attached Identity to Hotjar recording");
    }
  }, [userFields]);
  return null;
}, areEqual);

var _default = HotJarIdentifier;
exports["default"] = _default;